import store from "@/store/";
import { i18n } from "@/locales/index.js";

export default async ({ from, to, next }) => {
  if(store.getters["common/isCompleted"]('Confirmation'))
    return next({ name: 'Confirmation', params: {locale: i18n.locale} });
  else
    return next({ name: 'Consent', params: {locale: i18n.locale, confirm: to.params.confirm} });
}


// WEBPACK FOOTER //
// ./src/router/middleware/consent.js